module.exports = __webpack_public_path__ + "static/media/ws05.2f648894.webp";